<template>

<div>
  <LDBsTable
    url="arena/vehicletypes"
    defaultSort="id"
    defaultOrder="asc"
    :query="queryToUse"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-4">
      <label for="id">{{ $t('id') }}</label>
      <input
        type="text"
        id="id"
        name="id"
        class="form-control"
        :placeholder="$t('ph_id')"
        v-model="query.id"
        @input="upper('id')"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="description">{{ $t('description') }}</label>
      <input
        type="text"
        id="description"
        name="description"
        class="form-control"
        :placeholder="$t('ph_description')"
        v-model="query.TPV_DSC"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="code">{{ $t('code') }}</label>
      <input
        type="text"
        id="code"
        name="code"
        class="form-control"
        :placeholder="$t('ph_code')"
        v-model="query.TPV_COD"
      >
    </div>
  </LDBsTable>
</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import { mapState } from 'vuex'

export default {
  name: 'ArenaVehicleTypeList',

  components: {
    LDBsTable,
    Combobox
  },

  data () {
    return {
      columns: [
        {
          title: this.$t('ID'),
          field: 'id',
          sortable: true
        },
        {
          title: this.$t('description'),
          field: 'TPV_DSC',
          sortable: false
        },
        {
          title: this.$t('code'),
          field: 'TPV_COD',
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `
              <a
                href="#/main/arena/vehicle-type/${value}"
                class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-pen" />
              </a>
            `
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'arena_tipo_veiculo' }
      },
      queryToUse: {},
      query: {
        id: '',
        TPV_DSC: '',
        TPV_COD: ''
      }
    }
  },

  computed: {
    ...mapState({
      lastquery: state => state.filtershistory.query,
    })
  },

  methods: {
    clear() {
      this.query.id = ''
      this.query.TPV_DSC = ''
      this.query.TPV_COD = ''
    },

    upper(attr) {
      this.query[attr] = this.query[attr].toUpperCase()
    },
  },

  beforeMount() {
    this.queryToUse = this.lastquery['arenavehicletype'] ? this.lastquery['arenavehicletype'] : this.query
  },

  async mounted () {
    if (this.lastquery['arenavehicletype']) {
      for (const [key, value] of Object.entries(this.lastquery['arenavehicletype'])) {
        this.query[key] = value
      }
    }

    this.queryToUse = this.query
  },

  destroyed () {
    this.$store.dispatch(
      'filtershistory/setQuery',
      {
        key: 'arenavehicletype',
        query: this.query
      }
    )
  },
}

</script>
